"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Contact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="389" id="contactcta" className="relative w-full min-h-[80vh] flex items-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/air_conditioning_service_hero.png)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b md:bg-gradient-to-r from-blue-950/90 via-blue-950/70 to-transparent" aria-hidden="true" />

      {}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-24">
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-12 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="md:col-span-7 lg:col-span-6 flex flex-col items-center md:items-start text-center md:text-left">
            {}
            <span className="font-default text-xs md:text-sm tracking-[0.25em] uppercase mb-6 md:mb-8 text-blue-200">
              Get in touch today
            </span>

            {}
            <h2 className="font-default font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight mb-6 md:mb-8 text-white">
              Keep your space{" "}
              <em className="italic font-normal text-blue-400">
                perfectly cool
              </em>{" "}
              all year round.
            </h2>

            {}
            <p className="font-default text-base md:text-lg lg:text-xl leading-relaxed max-w-xl mb-10 md:mb-12 text-blue-50">
              From professional installation to routine maintenance, Coastline Air Conditioning Services provides expert climate control solutions for homes and businesses across Sussex and Surrey.
            </p>

            {}
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-8 md:mb-10">
              <Button asChild size="lg" className="h-12 px-8 rounded-lg text-sm font-bold tracking-wide shadow-lg hover:shadow-xl transition-all bg-blue-600 text-white hover:bg-blue-700">
                <Link to="/AirConditioningPage">
                  Book Your Service
                  <ArrowRight className="ml-1 size-4" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="h-12 px-8 rounded-lg text-sm font-bold tracking-wide bg-transparent border-2 border-white text-white hover:bg-white/10 transition-all">
                <Link to="/MaintenancePage">View Maintenance Plans</Link>
              </Button>
            </div>

            {}
            <p className="font-default text-[10px] md:text-xs tracking-[0.2em] uppercase text-blue-200/80">
              Professional Support · Fast Response Times
            </p>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-white/15" aria-hidden="true" />
    </section>;
}